module.exports = __webpack_public_path__ + "img/logo-bbb.19b736b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/logo-bbb.png
// module id = D0Th
// module chunks = 0 1 2 3 4 5 6